import { DataLayerEventsModels } from '../types/data-layer-models';

interface DataLayer<T> {
  push: (data: T) => void;
}

const pushToDataLayer = <T>(data: T, clearPrevEcommerce: boolean): void => {
  const dataLayer = window?.dataLayer as DataLayer<T> | undefined;

  if (dataLayer) {
    if (!!clearPrevEcommerce) {
      dataLayer.push({ ecommerce: null } as any);
    }
    dataLayer.push(data);
  } else {
    console.error('Data layer not found');
  }
};

export function triggerGAEvent<TEvent extends DataLayerEventsModels>(
  data: TEvent,
  clearPrevEcommerce = false
): void {
  pushToDataLayer(data, clearPrevEcommerce);
}
